module.exports = __webpack_public_path__ + "static/media/IndhiraGandhi.fb8fb340.jpeg";